import { useMutation } from "@apollo/client/react";
import { graphql, type ResultOf, type VariablesOf } from "@tucan/graphql";
import { PROFILE_FRAGMENT } from "./profile.fragment";

export const MUTATION = graphql(
  `
    mutation updateProfile($profile: ProfileInput!) {
      updateProfile(profile: $profile) {
        ...Profile
      }
    }
  `,
  [PROFILE_FRAGMENT],
);

export type Data = ResultOf<typeof MUTATION>;
export type Variables = VariablesOf<typeof MUTATION>;

export const useUpdateProfileMutation = (
  options: useMutation.Options<Data, Variables> = {},
): useMutation.ResultTuple<Data, Variables> =>
  useMutation<Data, Variables>(MUTATION, options);
